// src/pages/SsoCallback.js
import React, { useEffect, useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { generateRoleToken } from "../../api/users";
import { getRedirectLocation } from "../../commons/js/utils/routes";
import RolePopup from "../RolePopup";
import userProfile from "../../commons/images/bki-logo-mbl.png";

const SSOCallback = () => {
    const history = useHistory();

    const dispatch = useDispatch();

    const [showRolePopup, setShowRolePopup] = useState(false);
    const [userRoles, setUserRoles] = useState([]);

    const handleRoleSelect = (userRole) => {
        let role = userRole.role_id;
        let userId = Number(localStorage.getItem("userId"));
        let token = localStorage.getItem("token");
        (async () => {
            let response;
            try {
                response = await generateRoleToken(userId, role);
                if (response && response.headers["x-role-token"]) {
                    localStorage.setItem("token", token);
                    localStorage.setItem("roleId", role);
                    localStorage.setItem(
                        "role-token",
                        response.headers["x-role-token"]
                    );
                    localStorage.setItem("userId", response.data.user_id);
                    localStorage.setItem("email", response.data.email);
                    localStorage.setItem(
                        "isScheduler",
                        response.data.scheduler
                    );
                    const profilePic = response.data.thumb_url || userProfile;
                    dispatch({
                        type: "SET_LOGGED_IN",
                        payload: {
                            value: true,
                            role,
                        },
                    });
                    dispatch({
                        type: "SET_PROFILE_PICTURE",
                        payload: {
                            value: profilePic,
                        },
                    });
                }
            } catch (e) {
                toast.error("Oops! Something went wrong. Please try again.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                });
                return;
            }
        })();
    };

    useEffect(() => {
        const handleSSO = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get("access_token");
            const roleToken = urlParams.get("role_token");
            const userId = urlParams.get("user_id");

            if (!token && !userId) {
                history.push("/login");
                return;
            }

            try {
                const headers = {
                    "X-Access-Token": token,
                };

                if (roleToken) {
                    headers["X-Role-Token"] = roleToken;
                }
                const response = await axios.get(
                    `${process.env.REACT_APP_BASEURL}users/${userId}`,
                    { headers }
                );

                if (response) {
                    localStorage.setItem("token", token);
                    localStorage.setItem("role-token", roleToken);
                    localStorage.setItem("userId", userId);
                    localStorage.setItem("email", response.data.email);
                    localStorage.setItem(
                        "isScheduler",
                        response.data.scheduler
                    );

                    if (response.data.roles.length === 1) {
                        localStorage.setItem(
                            "roleId",
                            response.data.roles[0].role_id
                        );
                        const redirectLocation = getRedirectLocation();
                        return <Redirect to={`${redirectLocation}`} />;
                    } else {
                        const userRoles = response.data.roles;
                        setShowRolePopup(true);
                        setUserRoles(userRoles);
                    }
                }
            } catch (error) {
                history.push("/login");
                toast.error("SSO authentication failed. Please try again.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                });
                return;
            }
        };

        handleSSO();
    }, []);

    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
        >
            Processing SSO login...
            {showRolePopup && (
                <RolePopup
                    handleRoleSelect={handleRoleSelect}
                    userRoles={userRoles}
                    showRolePopup={true}
                />
            )}
        </div>
    );
};

export default SSOCallback;
